import { DashboardTwoTone } from "@mui/icons-material";

export const DASHBOARD_ACTION = {
    RESET_DASHBOARD_STATE: "RESET_DASHBOARD_STATE",
    REQUEST_DASHBOARD_LIST:"REQUEST_DASHBOARD_LIST",
    RESPONSE_DASHBOARD_LIST:"RESPONSE_DASHBOARD_LIST",
    ERROR_DASHBOARD_LIST:"ERROR_DASHBOARD_LIST",

    RESET_EMP_DASHBOARD_STATE: "RESET_EMP_DASHBOARD_STATE",
    REQUEST_EMP_DASHBOARD_LIST:"REQUEST_EMP_DASHBOARD_LIST",
    RESPONSE_EMP_DASHBOARD_LIST:"RESPONSE_EMP_DASHBOARD_LIST",
    ERROR_EMP_DASHBOARD_LIST:"ERROR_EMP_DASHBOARD_LIST",

    RESET_DASHBOARD_MONTHLYHOURS_STATE: "RESET_DASHBOARD_MONTHLYHOURS_STATE",
    REQUEST_DASHBOARD_MONTHLYHOURS: "REQUEST_DASHBOARD_MONTHLYHOURS",
    RESPONSE_DASHBOARD_MONTHLYHOURS: "RESPONSE_DASHBOARD_MONTHLYHOURS",
    ERROR_DASHBOARD_MONTHLYHOURS: "ERROR_DASHBOARD_MONTHLYHOURS",
};

export const setResetDashboardMonthlyHours = () => ({
    type: DASHBOARD_ACTION.RESET_DASHBOARD_MONTHLYHOURS_STATE,
    data: undefined
});

export const requestDashboardMonthlyHours = (params) => ({
type: DASHBOARD_ACTION.REQUEST_DASHBOARD_MONTHLYHOURS,
data: params
});

export const responseDashboardMonthlyHours = (res) => ({
    type: DASHBOARD_ACTION.RESPONSE_DASHBOARD_MONTHLYHOURS,
    data: res
});

export const errorDashboardMonthlyHours = (err) => ({
    type: DASHBOARD_ACTION.ERROR_DASHBOARD_MONTHLYHOURS,
    data: err
});


export const setResetStateDashboardList = () => ({
    type: DASHBOARD_ACTION.RESET_DASHBOARD_STATE,
    data: undefined
});

export const requestDashboardList = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_DASHBOARD_LIST,
    data: params
});

export const responseDashboardList = (res) => ({
type: DASHBOARD_ACTION.RESPONSE_DASHBOARD_LIST,
data: res
});

export const errorDashboardList = (err) => ({
    type: DASHBOARD_ACTION.ERROR_DASHBOARD_LIST,
    data: err
});

export const setResetStateEmpDashboardList = () => ({
    type: DASHBOARD_ACTION.RESET_EMP_DASHBOARD_STATE,
    data: undefined
});

export const requestEmpDashboardList = (params) => ({
    type: DASHBOARD_ACTION.REQUEST_EMP_DASHBOARD_LIST,
    data: params
});

export const responseEmpDashboardList = (res) => ({ 
    type: DASHBOARD_ACTION.RESPONSE_EMP_DASHBOARD_LIST,
    data: res
});

export const errorEmpDashboardList = (err) => ({
    type: DASHBOARD_ACTION.ERROR_EMP_DASHBOARD_LIST,
    data: err
});
